import React, { Component } from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import CenteredProgress from "./CenteredProgress";
import UserListSection from "./UserListSection";
import { grey } from "material-ui/colors";

const styles = theme => ({
  root: {
    flexGrow: 1
  },
  subheader: {
    backgroundColor: grey[100]
  }
});

class AccountPeople extends Component {
  componentDidMount() {
    this.props.fetchUsers();
  }

  renderSections() {
    const { users } = this.props;
    return users.map((section, i) => (
      <UserListSection key={i} header={section.heading} users={section.users} />
    ));
  }

  render() {
    const { classes, loading } = this.props;
    if (loading) {
      return <CenteredProgress />;
    }
    return <div className={classes.root}>{this.renderSections()}</div>;
  }
}

AccountPeople.propTypes = {
  users: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  classes: PropTypes.object.isRequired,
  fetchUsers: PropTypes.func.isRequired
};

export { AccountPeople };

export default withStyles(styles, { name: "AccountPeople" })(AccountPeople);



// WEBPACK FOOTER //
// ./src/AccountPeople.js